import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { createLogger } from "../../utils/logger";

const logger = createLogger("MobileRedirect");
const MobileRedirect = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const app = params.get("app");
    const action = params.get("action");
    const mode = params.get("mode");

    logger.log("Mobile redirect params:", { app, action, mode });

    if (app === "panidelivery" && action === "banking") {
      // Construct the deep link URL
      const deepLink = `panidelivery://banking?mode=${mode || "complete"}`;
      logger.log("Attempting to redirect to:", deepLink);

      // Try to redirect to the mobile app
      window.location.href = deepLink;

      // Fallback: Show instructions if deep link doesn't work
      setTimeout(() => {
        logger.log("Deep link may not have worked, showing fallback message");
      }, 3000);
    }
  }, [location]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        padding: "20px",
        textAlign: "center"
      }}
    >
      <h2>Redirecting to Panichefs Delivery App...</h2>
      <p>
        If the app doesn't open automatically, please open the Panichefs
        Delivery app manually.
      </p>
      <div style={{ marginTop: "20px" }}>
        <p style={{ fontSize: "14px", color: "#666" }}>
          Banking setup completed successfully. You can now close this page.
        </p>
      </div>
    </div>
  );
};

export default MobileRedirect;
